export const BASE_NAME = "/";
export enum BasicRoutePath {
  Login = "/login",
  Home = "/",
  Approvals = "/approvals",
  Requests = "/requests",
  ContractorProfile = "/contractor-profile",
}

export enum ApprovalsTab {
  Inbox = "inbox",
  Tracking = "tracking",
}

export enum ContractorTab {
  Contractor = "contractor",
  Subcontractor = "subcontractor",
}

export enum ContractorPage {
  Edit = "details",
}

export enum SubcontractorPage {
  List = "list",
  // Search = "search",
  Edit = "edit",
}

export const DEFAULT_DOMAIN_ID = "9";

export const APPROVALS_TAB_PATH = `${BasicRoutePath.Approvals}/:tab`;

export const CONTRACTOR_PAGE_ROOT_PATH = `${BasicRoutePath.ContractorProfile}/${ContractorTab.Contractor}`;
export const SUB_CONTRACTOR_PAGE_ROOT_PATH = `${BasicRoutePath.ContractorProfile}/${ContractorTab.Subcontractor}`;
